import React from 'react';
import { FirmAdminLayout } from './FirmAdminLayout';
import { PlanSubscription } from './PlanSubscription';

export const SubscriptionPage: React.FC = () => {
  return (
    <FirmAdminLayout>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Subscription Management</h1>
          <p className="text-gray-600">
            View and manage your firm's subscription plan, billing history, and payment options.
          </p>
        </div>
        <PlanSubscription />
      </div>
    </FirmAdminLayout>
  );
};
